module.exports = __webpack_public_path__ + "assets/sendMessageArrowIcon.89b24c0d.svg";